module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-text-field', {
    ref: "searchText",
    staticClass: "ma-2",
    attrs: {
      "hide-details": "",
      "label": "Search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _vm._l((_vm.menu.categories), function(category) {
    return _c('div', {
      key: category.category.name
    }, [_c('div', {
      staticClass: "heading pa-2"
    }, [_vm._v(_vm._s(category.category.name))]), _vm._v(" "), _c('div', {
      staticClass: "scroll",
      staticStyle: {
        "max-height": "200px",
        "border-bottom": "dotted 2px #d8d8d8"
      }
    }, [_vm._l((category.policies), function(policy) {
      return [_c('v-tooltip', {
        key: policy.key,
        attrs: {
          "right": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [(_vm.matchesSearch(policy.name)) ? _c('div', _vm._g({
              directives: [{
                name: "ripple",
                rawName: "v-ripple"
              }],
              key: policy.name,
              staticClass: "list-tile clickable hoverable",
              class: {
                'blue-hilight': _vm.isSelected(policy.name)
              },
              on: {
                "click": function($event) {
                  return _vm.$emit('click', policy)
                }
              }
            }, on), [_vm._v("\n                        " + _vm._s(policy.name) + " \n                    ")]) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(policy.templateName))])])]
    }), _vm._v(" "), (!_vm.search) ? _c('div', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      staticClass: "list-tile clickable hoverable",
      on: {
        "click": function($event) {
          return _vm.addDocument(category.category)
        }
      }
    }, [_vm._v("\n                Add " + _vm._s(category.category.name) + " Doc\n            ")]) : _vm._e()], 2)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-467d54d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/ChecklistMenu.vue
// module id = 2531
// module chunks = 1